import { Link } from 'react-router-dom';
import { useTranslation, useI18n } from '../i18n';

export default function NotFoundPage() {
  const t = useTranslation();
  const { locale } = useI18n();
  return (
    <div style={{ maxWidth: 480, margin: '120px auto', textAlign: 'center', padding: '0 24px' }}>
      <h1>{t('404.title')}</h1>
      <p style={{ color: 'var(--c-muted)' }}>{t('404.body')}</p>
      <p><Link to={`/${locale}/overview`}>{t('404.back')}</Link></p>
    </div>
  );
}
